import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ModalHeaderExtended from '../bootstrap/ModalHeader.js';
import { ModalContext } from '../Modal/Modal';
import CloseButton from '../CloseButton/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ModalHeader(_ref) {
  let {
    closeButton = false,
    children
  } = _ref;
  const {
    onHide
  } = useContext(ModalContext) || {};
  return /*#__PURE__*/_jsxs(ModalHeaderExtended, {
    children: [children, closeButton && /*#__PURE__*/_jsx(CloseButton, {
      onClick: onHide
    })]
  });
}
export default ModalHeader;